export default __webpack_public_path__ + "static/media/lefteye.d08cf16b.svg";